import DateFormatter from "./DateFormatter";
import CalendarEventJson from "./CalendarEventJson";

/**
 * Needed functions for calendar view
 */

export default {
   getEventsAtWeek(events: CalendarEventJson[], calWeek: number): CalendarEventJson[] | undefined {
      if (events != null) {
         var eventsAtWeek: CalendarEventJson[];

         function filterByCalWeek(item: any) {
            let beginCalWeek = DateFormatter.getCalendarWeek(new Date(item.beginDateTime));
            let endCalWeek = DateFormatter.getCalendarWeek(new Date(item.endDateTime));

            if (
               (beginCalWeek <= calWeek && endCalWeek >= calWeek)
               || (beginCalWeek < calWeek && endCalWeek == calWeek)
               || (beginCalWeek == calWeek && endCalWeek > calWeek)
            ) {
               return item;
            }
         }

         eventsAtWeek = events.filter(filterByCalWeek);

         eventsAtWeek = eventsAtWeek ? eventsAtWeek.sort((a, b) => new Date(a.beginDateTime).getTime() - new Date(b.beginDateTime).getTime()) : [];

         return eventsAtWeek;
      }
   },

   getEventsAtWeekAndMonth(events: CalendarEventJson[], calWeek: number, month: number): CalendarEventJson[] | undefined {
      if (events != null) {
         var eventsAtWeek: CalendarEventJson[];

         function filterByCalWeekAndMonth(item: any) {
            let beginCalWeek = DateFormatter.getCalendarWeek(new Date(item.beginDateTime));
            let endCalWeek = DateFormatter.getCalendarWeek(new Date(item.endDateTime));

            /* if(
               (beginCalWeek <= calWeek && endCalWeek >= calWeek)
               || (beginCalWeek < calWeek && endCalWeek == calWeek)
               || (beginCalWeek == calWeek && endCalWeek > calWeek)
            ) {
               return item
            } */

            /* if(
               ((beginCalWeek < calWeek && endCalWeek == calWeek) && (new Date(item.endDateTime).getMonth() == month))
               || ((beginCalWeek == calWeek && endCalWeek > calWeek) && (new Date(item.beginDateTime).getMonth() == month))
               || ((beginCalWeek == calWeek && endCalWeek == calWeek) && ((new Date(item.beginDateTime).getMonth() == month) || (new Date(item.endDateTime).getMonth() == month)))
               || (beginCalWeek < calWeek && endCalWeek > calWeek)
            ) {
               return item
            } */

            if (
               ((beginCalWeek <= calWeek && endCalWeek >= calWeek)
                  && ((new Date(item.beginDateTime).getMonth() == month) || (new Date(item.endDateTime).getMonth() == month)))
            ) {
               return item;
            }
         }

         eventsAtWeek = events.filter(filterByCalWeekAndMonth);

         eventsAtWeek = eventsAtWeek ? eventsAtWeek.sort((a, b) => new Date(a.beginDateTime).getTime() - new Date(b.beginDateTime).getTime()) : [];

         return eventsAtWeek;
      }
   },

   getGridColumn(event: CalendarEventJson, year: number, month: number, calWeek: number) {
      if (month != null && year != null) {
         let beginDate = new Date(event.beginDateTime);
         let endDate = new Date(event.endDateTime);

         let firstOfMonth = new Date(year, month, 1);
         let lastOfMonth = new Date(year, month + 1, 0);

         let beginCalWeek = DateFormatter.getCalendarWeek(beginDate);
         let endCalWeek = DateFormatter.getCalendarWeek(endDate);

         let beginDayDate = beginDate.getDate();
         let endDayDate = endDate.getDate();

         let gridColumnString = '';
         let gridColumnStart = '';
         let gridColumnEnd = '';

         if (beginCalWeek == calWeek && endCalWeek == calWeek) {
            gridColumnStart = 'date' + beginDayDate;
            gridColumnEnd = 'date' + endDayDate;
         } else if (beginCalWeek == calWeek && endCalWeek > calWeek) {
            gridColumnStart = 'date' + beginDayDate;
            gridColumnEnd = '-1';
         } else if (beginCalWeek < calWeek && endCalWeek == calWeek) {
            gridColumnStart = '1';
            gridColumnEnd = 'date' + endDayDate;
         } else if (beginCalWeek < calWeek && endCalWeek > calWeek) {
            gridColumnStart = '1';
            gridColumnEnd = '-1';
         }

         if ((beginDate.getFullYear() < endDate.getFullYear()) || (beginDate.getMonth() < endDate.getMonth())) {
            if (DateFormatter.getCalendarWeek(firstOfMonth) == calWeek) {
               gridColumnStart = 'date' + firstOfMonth.getDate();
            } else if (DateFormatter.getCalendarWeek(lastOfMonth) == calWeek) {
               gridColumnEnd = 'date' + lastOfMonth.getDate();
            }
         }

         gridColumnString = gridColumnStart + ' / ' + gridColumnEnd;

         return gridColumnString;
      }
   },

   getWeekOverflowStyle(event: CalendarEventJson, year: number, month: number, calWeek: number) {
      if (month != null && year != null) {
         let beginDate = new Date(event.beginDateTime);
         let endDate = new Date(event.endDateTime);

         let firstOfMonth = new Date(year, month, 1);
         let lastOfMonth = new Date(year, month + 1, 0);

         let beginCalWeek = DateFormatter.getCalendarWeek(new Date(event.beginDateTime));
         let endCalWeek = DateFormatter.getCalendarWeek(new Date(event.endDateTime));

         let classString = '';

         if (beginCalWeek == calWeek && endCalWeek > calWeek) {
            classString = 'end-open';
         } else if (beginCalWeek < calWeek && endCalWeek == calWeek) {
            classString = 'start-open';
         } else if (beginCalWeek < calWeek && endCalWeek > calWeek) {
            classString = 'start-open end-open';
         }

         if ((beginDate.getFullYear() < endDate.getFullYear()) || (beginDate.getMonth() < endDate.getMonth())) {
            if (DateFormatter.getCalendarWeek(firstOfMonth) == calWeek) {
               classString += ' start-open';
            } else if (DateFormatter.getCalendarWeek(lastOfMonth) == calWeek) {
               classString += ' end-open';
            }
         }

         return classString;
      }
   },
};